import React from "react";
import { Link } from "react-router-dom";
import "../css/footer.scss";

function Footer() {
  const toTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <footer className="site-footer" role="contentinfo">
      <div className="footer-container">
        <div className="footer-left">
          <Link to="/" onClick={toTop} className="footer-logo-link">
            <img
              src="/brand/petoutlet-logo.svg"
              alt="Petoutlet"
              className="footer-brand-logo"
            />
          </Link>
          <p>audit@petoutlet.work</p>
          <p>
            HANG LOK BUILDING WING LOK STREET 130 CENTRAL AND WESTERN DISTRICT
            HONG KONG
          </p>
        </div>

        <div className="footer-links-section">
          <div className="footer-column">
            <h4>Shop Petoutlet</h4>
            <ul>
              <li>
                <Link to="/shop" onClick={toTop}>
                  All Products
                </Link>
              </li>
            </ul>
          </div>

          <div className="footer-column">
            <h4>Company</h4>
            <ul>
              <li>
                <Link to="/about" onClick={toTop}>
                  Our Story
                </Link>
              </li>
            </ul>
          </div>

          <div className="footer-column">
            <h4>Support</h4>
            <ul>
              <li>
                <Link to="/contact" onClick={toTop}>
                  Contact Us
                </Link>
              </li>
              <li>
                <Link to="/shipping" onClick={toTop}>
                  Shipping Policy
                </Link>
              </li>
              <li>
                <Link to="/returns" onClick={toTop}>
                  Returns Policy
                </Link>
              </li>
              <li>
                <Link to="/terms" onClick={toTop}>
                  Terms of Service
                </Link>
              </li>
              <li>
                <Link to="/privacy" onClick={toTop}>
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link to="/cookies" onClick={toTop}>
                  Cookie Policy
                </Link>
              </li>
              <li>
                <Link to="/faqs" onClick={toTop}>
                  FAQs
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
